import { Injectable } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoCompleteTriggerService {

  private closeAllSubject = new Subject<void>();
  closeAll$ = this.closeAllSubject.asObservable();

  closeAll() {
    this.closeAllSubject.next();
  }
}
